import bigDis1 from "../images/bigDis1.webp";
import bigDis2 from "../images/bigDis2.webp";
import bigDis3 from "../images/bigDis3.webp";
import bigDis4 from "../images/bigDis4.webp";
import bigDis5 from "../images/bigDis5.webp";
import bigDis6 from "../images/bigDis6.webp";
import bigDis7 from "../images/bigDis7.webp";
import bigDis8 from "../images/bigDis8.webp";
import bigDis9 from "../images/bigDis9.webp";

export const bigDiscount = [
  {
    img: bigDis1,
    text: "BenX 2020",
    discountPrice: "$209.70",
    originalPrice: "$233.00",
  },
  {
    img: bigDis2,
    text: "Tony TV 1080p",
    discountPrice: "$258.54",
    originalPrice: "$278.00",
  },
  {
    img: bigDis3,
    text: "Tony PS4",
    discountPrice: "$168.15",
    originalPrice: "$177.00",
  },
  {
    img: bigDis4,
    text: "Setgearr 2020",
    discountPrice: "$111.60",
    originalPrice: "$124.00",
  },
  {
    img: bigDis5,
    text: "Tony BGB",
    discountPrice: "$269.80",
    originalPrice: "$284.00",
  },
  {
    img: bigDis6,
    text: "RG products",
    discountPrice: "$270.00",
    originalPrice: "$300.00",
  },
  {
    img: bigDis7,
    text: "BenX 2020",
    discountPrice: "$209.70",
    originalPrice: "$233.00",
  },
  {
    img: bigDis8,
    text: "BenX 2020",
    discountPrice: "$209.70",
    originalPrice: "$233.00",
  },
  {
    img: bigDis9,
    text: "BenX 2020",
    discountPrice: "$209.70",
    originalPrice: "$233.00",
  },
];
